import "./Footer.scss";

function Footer() {
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer__wrapper">
                    <div className="footer__wrapper__copy">
                        <p>&copy; 2026 Encode Bytes</p>
                        <p>65.511.011/0001-81</p>
                        <p>comercial@encodebytes.com.br</p>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;